import InstallIntegrationPage from './InstallIntegrationPage'

export default InstallIntegrationPage
